<p-dialog
  header="Allocate Truck"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  (onShow)="onShow()"
  [style]="{ width: '60%' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row" style="margin-bottom: 5px">Select task</div>
    <div class="ui-grid-row">
      <p-table
        selectionMode="single"
        [value]="tasks"
        [responsive]="true"
        rowHover="true"
        resizableColumns="true"
        [(selection)]="selectedTask"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>From</th>
            <th>To</th>
            <th>Latest Pickup</th>
            <th>Latest Dropoff</th>
            <th>Movement Type</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-itemUntyped>
          <ng-container *ngIf="asAssignTruckTask(itemUntyped) as item">
            <tr [pSelectableRow]="item">
              <td>{{ item.pickupLocation.primaryAddress }}</td>
              <td>{{ item.dropoffLocation.primaryAddress }}</td>
              <td>{{ item.pickupLatestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}</td>
              <td>{{ item.dropoffLatestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}</td>
              <td>{{ item.taskType }}</td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </div>
    <div class="ui-grid-row" style="margin-top: 20px">
      <div class="ui-g-6">
        <div class="ui-grid-col-4"><label>Truck</label></div>
        <div class="ui-grid-col-8">
          <p-dropdown
            name="dialogTrucks"
            [options]="supplierTrucks"
            [(ngModel)]="selectedTruckId"
            [style]="{ width: '100%' }"
            appendTo="body"
            placeholder="Select truck"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row" style="float: right">
    <button
      type="button"
      class="green-btn"
      pButton
      icon="fa ui-icon-check"
      (click)="allocateTruck()"
      label="Allocate"
      [disabled]="!selectedTruckId || !selectedTask"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="visibleChange.emit(false)"
    ></button>
  </div>
</p-dialog>
